import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './style';
import settings from '../../services/settings.json';

const { light, primary } = settings.color;
const { bold } = settings.fontWeight;

const Button = ({
	backgroundcolor,
	color,
    border,
    borderRadius,
    children,
    disabled,
    display,
    fontSize,
    fontWeight,
    height,
    id,
    lineheight,
    margin,
    onClick,
    padding,
    shadow,
    textColor,
    theme,
    uppercase,
	width,
	position,
	top,
	bottom,
	left,
	right,
	type,
	to,
	target,
}) => {
	const Component = type === 'link' ? Styled.Link : Styled.Button;

	return (
		<Component
			backgroundcolor={backgroundcolor}
			color={color}
			borderRadius={borderRadius}
			border={border}
			disabled={disabled}
			display={display}
			fontSize={fontSize}
			fontWeight={fontWeight}
			height={height}
			id={id}
			lineheight={lineheight}
			margin={margin}
			onClick={onClick}
			padding={padding}
			shadow={shadow}
			textColor={textColor}
			theme={theme}
			uppercase={uppercase}
			width={width}
			position={position}
			top={top}
			bottom={bottom}
			left={left}
			right={right}
			to={type === 'link' && to}
			target={target}
		>
			{children}
		</Component>
	);
};

Button.defaultProps = {
	backgroundcolor: primary,
	color: light,
    border: 'none',
    borderRadius: '8px',
    disabled: false,
    display: 'flex',
    fontSize: '0.75rem',
    fontWeight: bold,
    height: '',
    lineheight: 'inherit',
    margin: '0',
    onClick: () => {},
    padding: '0',
    shadow: 'none',
    textColor: light,
    theme: '',
    uppercase: 'unset',
	width: '100%',
	position: 'relative',
	top: '',
	bottom: '',
	left: '',
	right: '',
	type: 'button',
	to: '',
	target: '_blank',
};

PropTypes.Button = {
	backgroundcolor: PropTypes.string,
	color: PropTypes.string,
    border: PropTypes.string,
    borderRadius: PropTypes.string,
    children: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    display: PropTypes.string,
    fontSize: PropTypes.string,
    fontWeight: PropTypes.number,
    height: PropTypes.string,
    id: PropTypes.string,
    lineheight: PropTypes.string,
    margin: PropTypes.string,
    onClick: PropTypes.func,
    padding: PropTypes.string,
    shadow: PropTypes.bool,
    textColor: PropTypes.string,
    theme: PropTypes.string,
    uppercase: PropTypes.bool,
	width: PropTypes.bool,
	position: PropTypes.string,
	top: PropTypes.string,
	bottom: PropTypes.string,
	left: PropTypes.string,
	right: PropTypes.string,
	type: PropTypes.string,
	to: PropTypes.string,
	target: PropTypes.string,
};

export default Button;
